// Patrimoine UI labels & tones
export const BUILDING_TYPE_LABELS = {
  immeuble: "Immeuble",
  maison: "Maison",
  appartement: "Appartement",
  studio: "Studio",
  local_commercial: "Local commercial",
  bureau: "Bureau",
  entrepot: "Entrepôt",
  batiment_industriel: "Bâtiment industriel",
  garage: "Garage",
  box: "Box",
  stationnement: "Place de stationnement",
  terrain: "Terrain",
  cellule_stockage: "Cellule de stockage",
  dependance: "Dépendance",
  autre: "Autre",
};

export const BUILDING_STATUS_LABELS = {
  in_operation: "En exploitation",
  works: "En travaux",
  vacant: "Vacant",
  for_sale: "En vente",
  archived: "Archivé",
};

export const BUILDING_STATUS_TONES = {
  in_operation: "success",
  works: "warning",
  vacant: "warning",
  for_sale: "info",
  archived: "neutral",
};

export const OWNERSHIP_REGIME_LABELS = {
  copropriete: "Copropriété",
  pleine_propriete: "Pleine propriété",
  monopropriete: "Monopropriété",
  indivision: "Indivision",
};

export const OCCUPANCY_STATUS_LABELS = {
  occupied: "Occupé",
  vacant: "Vacant",
  under_works: "En travaux",
  reserved: "Réservé",
};

export const OCCUPANCY_STATUS_TONES = {
  occupied: "success",
  vacant: "warning",
  under_works: "info",
  reserved: "accent",
};

export const METER_TYPE_LABELS = {
  individual: "Individuel",
  collective: "Collectif",
  mixed: "Mixte",
  none: "Non applicable",
};

export const ALLOCATION_KEY_LABELS = {
  equal: "Répartition égale",
  surface: "Au prorata de la surface",
  tantiemes: "Au prorata des tantièmes",
  lot_count: "Par nombre de lots",
  custom: "Personnalisée",
  none: "Aucune répartition",
};

export const CHARGE_CATEGORY_LABELS = {
  taxe_fonciere: "Taxe foncière",
  assurance_pno: "Assurance PNO",
  eau: "Eau",
  elec: "Électricité",
  gaz: "Gaz",
  entretien: "Entretien",
  autre: "Autre",
};

export const HISTORY_ACTION_LABELS = {
  create: "Création",
  update: "Modification",
  delete: "Suppression",
  archived: "Archivage",
  value_changed: "Valeur estimée modifiée",
  owner_changed: "Changement de propriétaire",
  lots_bulk_create: "Ajout groupé de lots",
};
